import React, { Component } from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import Button from '../../common/components/Button';
import { getCopy } from '../../common/lib/copyDefaults';
import { clearIdvFlow, getIdvFlow } from '../../common/lib/idvFlowSession';
import { fetchUser, getRegistrationParams } from '../../services/auth';

import '../../../style/index.css';
import './migrationSuccess.css';

class MigrationSuccessView extends Component {
  constructor(props) {
    super(props);
    this.handleExploreClick = this.handleExploreClick.bind(this);
    this.idvFlow = getIdvFlow();
  }

  componentDidMount() {
    clearIdvFlow();
    requestAnimationFrame(() => {
      const el = document.getElementById('migration-success-heading');
      if (el) {
        el.focus();
      }
    });
  }

  handleExploreClick(e) {
    e.preventDefault();
    const queryParams = queryString.parse(window.location.search);
    const registrationParams = getRegistrationParams();
    const callbackUri = registrationParams.callbackUri
      || _.get(queryParams, 'callbackUri', false);

    if (!callbackUri) {
      return;
    }

    const user = fetchUser();
    window.location.replace(
      `${callbackUri}?accessToken=${user.accessToken}&refreshToken=${user.refreshToken}&identityToken=${user.identityToken}&expiresIn=${user.expiresIn}`,
    );
  }

  render() {
    const copy = getCopy('/idv/success', { idvFlow: this.idvFlow });

    return (
      <div className="migration-success row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10">
          <div className="migration-success__body">
            <h1
              id="migration-success-heading"
              tabIndex={-1}
              className="migration-success__title"
            >
              {copy.header}
            </h1>
            <p className="migration-success__description">{copy.body}</p>
          </div>
          <div className="button-wrap">
            <Button
              label={copy.exploreLabel}
              onClickFn={this.handleExploreClick}
              className="nyl-button"
              id="migration-success-explore-button"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default MigrationSuccessView;
